import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

/* ------------- Toast reducer ------------- */
const defaultState = {
  idCount: 0,
  toasts: [],
  timeout: null,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.ADD_TOAST: {
      const { message, duration, type } = action.payload;
      const nextId = state.idCount + 1;
      const newToast = {
        message,
        duration,
        type,
        id: nextId,
      };
      const newToasts = Immutable([newToast].concat(state.toasts));
      return state.merge({
        idCount: nextId,
        toasts: newToasts,
      });
    }
    case actions.CLOSE_TOAST: {
      const result = state.toasts.find(t => t.id === action.payload.id);
      const index = state.toasts.indexOf(result);
      const newToasts = [...state.toasts];
      if (index !== -1) {
        newToasts.splice(index, 1);
      }
      return state.merge({
        toasts: Immutable(newToasts),
      });
    }
    case actions.SET_TIMEOUT: {
      const result = state.toasts.find(t => t.id === action.payload.id);
      const index = state.toasts.indexOf(result);
      const newToasts = [...state.toasts];
      if (!newToasts[index]) {
        return state;
      }
      newToasts[index] = newToasts[index].merge({
        timeout: action.payload.timeout,
      });
      return state.merge({
        toasts: Immutable(newToasts),
      });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

export const propTypes = {};



// WEBPACK FOOTER //
// ./src/redux/Toasts/reducer.js